var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-wrapper"},_vm._l((_vm.media),function(item,i){return _c('file-preview',{key:item.id,staticClass:"file-preview",class:{ selected: _vm.isSelected(item) },attrs:{"file":item},nativeOn:{"click":function($event){return _vm.onSelect(item, i)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }